import * as React from "react";
import { SVGProps } from "react";

const EthereumClassic = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1543 2499" {...props}>
    <defs>
      <style>{".cls-2{fill:#0b8311}"}</style>
    </defs>
    <g id="Layer_2" data-name="Layer 2">
      <g id="svg8">
        <g id="layer5">
          <g id="g1627">
            <path
              id="path1599"
              fill="#3ab83a"
              d="M0 1361.05c271.87 144.38 555.56 295.51 774.67 412.45L1543 1361.05c-278.2 413.29-510 757.36-768.33 1138.15C515.88 2119.25 230.08 1700 0 1361.05Zm29.55-114L775.51 849l736.25 395.14-735.83 398.49Zm745.12-525.58L0 1129.28 771.29 0 1543 1131.81 774.67 721.47Z"
            />
            <path
              id="path1593"
              d="M774.67 1773.5 1543 1361.05C1264.8 1774.34 774.67 2499.2 774.67 2499.2Zm.84-924.5 736.25 395.14-735.83 398.49-.42-793.63Zm-.84-127.5L771.29 0 1543 1131.81Z"
              className="cls-2"
            />
            <path
              id="path1603"
              d="m29.55 1247.06 746 61.22 736.25-63.75-735.87 398.52Z"
              className="cls-2"
            />
            <path
              id="path1606"
              fill="#146714"
              d="m775.51 1308.28 736.25-63.75-735.83 398.52-.42-334.77Z"
            />
          </g>
        </g>
      </g>
    </g>
  </svg>
);

export default EthereumClassic;
